function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00d6ff;}.cls-2{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M6.39,30.41A11.39,11.39,0,0,1,.45,28.87L0,24.47a10.67,10.67,0,0,0,6.29,2.15c2.16,0,3.59-1.11,3.59-2.83s-1-2.66-3.32-3.37C2.41,19.16.38,16.87.38,13.5S2.9,7,7.65,7a10.38,10.38,0,0,1,5.2,1.29L12,12a8.72,8.72,0,0,0-4.22-1.25c-2.06,0-3.18,1.14-3.18,2.5s1,2.19,3.07,2.83c4,1.29,6.6,3.3,6.6,7.35S11.56,30.41,6.39,30.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M18.26,30.16V7.31H30.69v3.76H22.63V16.8h6.7v3.8h-6.7v5.8h9.18v3.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M34.74,30.16V7.31h4.4V26.4h9.12v3.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M55.55,11.07V16.8h6.92v3.8H55.55v9.56H51.19V7.31H63.83v3.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M65.54,22v-3.4h9V22Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M85.76,11.07V30.16h-4.4V11.07H74.59V7.31H92.53v3.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M108.25,30.16l-6.5-9.53h-2v9.53H95.47V7.31h7.43c3.5,0,6.95,2.32,6.95,6.66a6.17,6.17,0,0,1-3.66,5.8l7.36,10.39Zm-6-19.09H99.76v6h2.45a3,3,0,1,0,0-6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M130,30.16l-2.13-5.51H120l-2.13,5.51h-4.22l9.15-23.1h2.48l9.11,23.1Zm-5.24-14c-.24-.68-.56-1.61-.8-2.47h-.07c-.21.86-.56,1.79-.8,2.47l-1.85,4.91h5.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M166.1,30.52l-9.6-10.75c-1.57-1.75-3.28-3.83-4.68-5.51l-.07,0c.07,1.87.07,3.69.07,5.27v10.6h-4.29V7.31h3.39l8.59,9.63c1.18,1.33,3,3.41,4.19,4.95l.07,0c-.07-1.58-.07-3.29-.07-4.84V7.31H168V30.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M173.09,30.16V7.31h4.4V30.16Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M201.2,30.52l-9.6-10.75c-1.58-1.75-3.29-3.83-4.68-5.51l-.07,0c.07,1.87.07,3.69.07,5.27v10.6h-4.3V7.31H186l8.59,9.63c1.19,1.33,3,3.41,4.19,4.95l.07,0c-.07-1.58-.07-3.29-.07-4.84V7.31h4.29V30.52Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M219.36,30.63c-6.08,0-12.29-4.12-12.29-11.9S213.45,6.8,219.18,6.8a13.54,13.54,0,0,1,7.23,1.83l-.8,3.84a11,11,0,0,0-5.94-1.72,7.87,7.87,0,0,0-8.21,8.13c0,5.08,3.81,8,8.1,8a6.93,6.93,0,0,0,3.88-.93V21.56H219V18h8.59V28.23C225.57,29.88,222.85,30.63,219.36,30.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M7.77,63.67V40.82h4.4V59.91h9.12v3.76Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M39.44,63.67l-2.13-5.52H29.46l-2.13,5.52H23.1l9.15-23.11h2.48l9.11,23.11Zm-5.23-14c-.25-.68-.56-1.61-.81-2.47h-.07c-.21.86-.56,1.79-.8,2.47l-1.85,4.91h5.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M54.84,63.67H47.09V40.82h6.78c3.21,0,6.38,2.14,6.38,6a4.49,4.49,0,0,1-2,3.91,6.24,6.24,0,0,1,4,5.91C62.28,61.24,58.68,63.67,54.84,63.67ZM53.17,44.33h-2v5.41h2c1.57,0,3-.79,3-2.69S54.74,44.33,53.17,44.33ZM54,53.14h-2.9v7.09H54c2,0,4-1.11,4-3.54S56.06,53.14,54,53.14Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M77.4,64.14A11.92,11.92,0,1,1,89.31,52.21,11.75,11.75,0,0,1,77.4,64.14Zm0-19.81a7.57,7.57,0,0,0-7.44,8,7.46,7.46,0,1,0,14.88,0A7.62,7.62,0,0,0,77.4,44.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M106.07,63.67l-6.5-9.53h-2v9.53H93.29V40.82h7.44c3.49,0,6.94,2.32,6.94,6.66a6.18,6.18,0,0,1-3.66,5.8l7.36,10.39Zm-6-19.09H97.58v6H100a3,3,0,1,0,0-6Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M127.82,63.67l-2.13-5.52h-7.85l-2.13,5.52h-4.23l9.15-23.11h2.48l9.11,23.11Zm-5.24-14c-.24-.68-.55-1.61-.8-2.47h-.07c-.21.86-.56,1.79-.8,2.47l-1.85,4.91h5.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M161.87,64.14a11.92,11.92,0,1,1,11.9-11.93A11.75,11.75,0,0,1,161.87,64.14Zm0-19.81a7.57,7.57,0,0,0-7.44,8,7.45,7.45,0,1,0,14.87,0A7.61,7.61,0,0,0,161.87,44.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M190.54,63.67,184,54.14h-2v9.53h-4.29V40.82h7.43c3.49,0,6.95,2.32,6.95,6.66a6.18,6.18,0,0,1-3.66,5.8l7.36,10.39Zm-6-19.09h-2.44v6h2.44c1.68,0,3.32-.94,3.32-3S186.21,44.58,184.49,44.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M206,53.28V63.67h-4.29V53.35l-8.42-12.53H198l4.09,6c.59.86,1.29,2,1.85,3h.07c.56-1,1.33-2.18,1.88-3l4-6h4.44Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M131.26,41.81h17.52v4.31h-6.61V74.27h-4.3V46.12h-6.61Zm10.91-7.28V0h-4.3V34.53H126.21v4.31h27.62V34.53Z"
})));

function SvgSelfTrainingLabBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 227.56 74.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfTrainingLabBlue);
export default __webpack_public_path__ + "static/media/self-training-lab-blue.51dca745.svg";
export { ForwardRef as ReactComponent };